import { useState } from "react";
import type { FaqItem } from "@/mocks/faq";

export default function AboutFaq({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-300/70 border-t border-b border-background-300/70 rounded-lg bg-background-100 px-5 md:px-6">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : index)}
                aria-expanded={open}
                className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-700 transition-colors">
                  {item.q}
                </span>
                <span
                  className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                    open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                </span>
              </button>
            </h3>
            {open && (
              <p className="pb-5 pr-10 text-sm text-foreground-600 leading-relaxed animate-fade-up">
                {item.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}